export const GLOBAL_ERROR_EVENT = "global-error";

export function emitGlobalError(payload) {
  window.dispatchEvent(new CustomEvent(GLOBAL_ERROR_EVENT, { detail: payload }));
} // 브라우저(window) 이벤트 버스에 이벤트 발생, 프론트에서만 발생